import { each, isNil } from 'lodash';
import { x } from '../_helpers';
import { carouselHook } from '../_helpers/constants';
import SwiperHelper from "../_helpers/swiper-helper";

export default class Carousels {
  list = {};

  constructor() {
    this.carousels = x(carouselHook);
    this.swHelper = new SwiperHelper();

    if (this.carousels) {
      this.init();
    }
  }

  initCarousel(el) {
    const _this = this;

    if (el.hasAttribute("js-carousel-gallery")) {
      const carousel = _this.swHelper.initGallery(el);
      _this.list[el.id || el.className] = _this.createGallery(el, carousel);
    } else {
      _this.list[el.id || el.className] = _this.swHelper.initBase(el);
    }
  }

  createGallery(el, carousel) {
    // ELEMENTS
    const paginationWrapper = el.parentNode.parentNode.querySelector('.swiper-info__pagination');
    const photoWrapper = el.parentNode.parentNode.querySelector(
      '.swiper-wrapper-info .swiper-info__photo'
    );

    const photoWrapperCaption = el.parentNode.parentNode.querySelector(
      '.swiper-wrapper-info-caption .swiper-info__photo-caption'
    );

    const fullscreenWrapper = el.parentNode.parentNode.querySelector('.swiper-info__fullscreen');
    const paginationCurrent = paginationWrapper.querySelector('.swiper-info__pagination--current');
    const paginationTotal = paginationWrapper.querySelector('.swiper-info__pagination--total');
    let photoCaption = photoWrapper
      ? photoWrapper.querySelector('.swiper-info__photo h1')
      : undefined;
    photoCaption = photoCaption
      ? photoCaption
      : photoWrapper.querySelector('.swiper-info__photo div');
    const photoDescription = photoWrapperCaption
      ? photoWrapperCaption.querySelector('.swiper-info__photo-caption span')
      : undefined;

    // FULLSCREEN
    fullscreenWrapper.addEventListener('click', () => {
      el.querySelector('.swiper-slide-active a').click();
    });

    // PAGINATION && TEXT
    carousel.on('paginationUpdate', (paginationEl) => {
      this.setPagination(paginationCurrent, paginationTotal, paginationEl);
    });
    carousel.on('slideChangeTransitionEnd', () => {
      const swiperTarget = el.querySelector('.swiper-slide-active a');
      this.setInfo(photoCaption, photoDescription, swiperTarget);
    });

    // INITIALIZE
    const target = el.querySelector('.swiper-slide-active a');

    this.setInfo(photoCaption, photoDescription, target);
    carousel.pagination.update();
  }

  setPagination(paginationCurrent, paginationTotal, paginationEl) {
    if (isNil(paginationEl) || isNil(paginationEl.querySelector)) return;

    if (paginationCurrent) {
      paginationCurrent.innerHTML = (
        paginationEl.querySelector('.swiper-pagination-current') || {
          innerText: '',
        }
      ).innerText;
    }
    if (paginationTotal) {
      paginationTotal.innerHTML = (
        paginationEl.querySelector('.swiper-pagination-total') || {
          innerText: '',
        }
      ).innerText;
    }
  }

  setInfo(photoCaption, photoDescription, target) {
    if (photoCaption) {
      const caption = target.getAttribute('data-caption');
      photoCaption.innerHTML = caption;
    }
    if (photoDescription) {
      const desc = target.getAttribute('data-desc');
      photoDescription.innerHTML = desc;
    }
  }

  handleEvents() {
    each(this.carousels, (el) => {
      this.initCarousel(el);
    });
  }

  init() {
    this.handleEvents();
  }
}
